import currencyFormatter from 'currency-formatter';
import { formatDate, parseDate } from 'helpers/date';
import { cleanCpfAndCnpj, formatCpfAndCnpj } from 'v2/helpers/cpfCnpj';

const masks = {
  phone: {
    apply: (value: string) => {
      if (!value) return value;

      const regexp = value.length > 10 ? /^(\d{0,2})(\d{0,5})(\d{0,4}).*/ : /^(\d{0,2})(\d{0,4})(\d{0,4}).*/;

      const result = value.length > 2 ? '($1) $2-$3' : '($1$2$3';

      return value.replace(regexp, result).replace(/-$/, '');
    },
    clean: (value: string) => (value ? value.replace(/\D/gi, '').substr(0, 11) : '')
  },
  creditCard: {
    apply: (value: string) => {
      if (!value) return value;
      const regexp = /^(\d{0,4})?(\d{0,4})?(\d{0,4})?(\d{0,4})?/;
      return value.replace(regexp, '$1  $2  $3  $4').replace(/-$/, '').trim();
    },
    clean: (value: string) => value.replace(/\D/gi, '').substr(0, 16)
  },
  date: {
    apply: (value: string, format: string = 'dd/MM/yyyy') => {
      return formatDate(value, format);
    },
    clean: (value: string) => {
      if (!value) return '';
      const parsed = parseDate(value);
      return parsed ? parsed.toISOString() : '';
    }
  },
  monthYear: {
    apply: (value: string) => {
      if (!value) return value;
      const regexp = /^(\d{2})(\d{0,2})?/;

      return value.replace(/\D/, '').replace(regexp, '$1/$2').replace(/-$/, '').trim();
    },
    clean: (value: string) => (value ? value.substr(0, 5) : '')
  },
  cpfCnpj: {
    apply: formatCpfAndCnpj,
    clean: cleanCpfAndCnpj
  },
  postalCode: {
    apply: (value: string) => {
      if (!value) return value;
      const regexp = /^(\d{5})(\d{3})?/;

      return value.replace(/\D/, '').replace(regexp, '$1-$2').replace(/-$/, '').trim();
    },
    clean: (value: string) => (value ? value.substr(0, 9) : '')
  },
  money: {
    apply: (value: string) => {
      if (value) {
        value = value.toString();

        if (value.match(/^\d+$/)) {
          value = `${value}.00`;
        }

        if (value.match(/^\d+\.\d+$/)) {
          value = Number(value).toFixed(2);
        }

        if (parseFloat(value) >= 0) {
          value = value.replace(/\D+/gi, '');
          const intval = value.substr(0, value.length - 2);
          const cents = value.substr(value.length - 2, 2);
          value = `${intval}.${cents}`;
        }
      }

      return currencyFormatter.format(Number(value), { code: 'BRL', precision: 2, symbol: '' });
    },
    clean: (value: string) => value
  }
};

export default masks;
